<template>

  <div class="gray-bg" style="min-height: 100vh">

    <div class="middle-box text-center loginscreen animated fadeInDown">
      <div>

        <div>
          <a target="_blank" href="https://www.snatchpark.com/parkbills/">
            <img src="/static/image/parkbills.png">
          </a>
          <img src="/static/image/park_bills_text_black.png">
        </div>

        <h3>Welcome to ParkBills.</h3>
        <h4>Please select a profile type to proceed</h4>

        <div class="wrapper wrapper-content animated fadeInRight">
          <div class="row">
            <div class="col-lg-12">
              <div class="contact-box">
                <a class="row" v-bind:href="helper.WEB_URL + '/companyForm'">
                  <!--
                  <div class="col-4">
                    <div class="text-center">
                      <img alt="image" class="rounded-circle m-t-xs img-fluid" src="img/a2.jpg">
                      <div class="m-t-xs font-bold">Graphics designer</div>
                    </div>
                  </div>
                  -->
                  <div class="col-8">
                    <h3><strong>Company</strong></h3>
                    <!--
                    <p><i class="fa fa-map-marker"></i> Riviera State 32/106</p>
                    <address>
                      <strong>Twitter, Inc.</strong><br>
                      795 Folsom Ave, Suite 600<br>
                      San Francisco, CA 94107<br>
                      <abbr title="Phone">P:</abbr> (123) 456-7890
                    </address>
                    -->
                  </div>
                </a>
              </div>
            </div>
            <div class="col-lg-12">
              <div class="contact-box">
                <a class="row" v-bind:href="helper.WEB_URL + '/personalForm'">
                  <div class="col-8">
                    <h3><strong>Personal</strong></h3>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>

        <p class="m-t">
          <small><strong>Copyright</strong> PARKAIDE &copy; 2018</small>
        </p>

      </div>
    </div>

  </div>

</template>

<script>
import helper from "@/components/Utility/Helper"

export default {
  name: "PageNoProfile",
  data(){
    return {
      helper : helper,
      username : "",
      password : "",
      error : ""
    }
  },
  mounted() {
    if(window.location.href.includes('localhost')) {
      document.title = 'Localhost';
    } else if(window.location.href.includes('parkbills.parkaidemobile.com')) {
      document.title = 'ParkBills Dev';
    } else if(window.location.href.includes('devpbills.parkaidemobile.com')) {
      document.title = 'ParkBills Dev';
    }
  },
  methods : {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Page/User/PageNoProfile.vue